import React from 'react';
import styled from './StatusOk.module.css';
import statusOk from '../../../../assets/images/statusOkIcon.svg';

const StatusOk: React.FC = () => {
    return <img src={statusOk} alt="Status Ok" className={styled.Img} />;
};

export default StatusOk;
